import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { openAdobeExchange } from '../utils/analytics';
import { INSTALL_PAGE_PATH } from '../constants/urls';
import './Header.css';

const Header: React.FC = () => {
  const { t } = useTranslation('common');

  const handleInstallClick = () => {
    openAdobeExchange('header');
  };

  return (
    <motion.header
      className="header"
      initial={{ y: -100, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: 'easeOut' }}
    >
      <div className="header-container">
        <motion.div
          className="logo"
          whileHover={{ scale: 1.05 }}
          transition={{ duration: 0.2 }}
        >
          <Link to="/" className="logo-link">
            <span className="logo-text">Substyle</span>
          </Link>
        </motion.div>
        <nav className="nav">
          <Link to={INSTALL_PAGE_PATH} className="nav-link">
            {t('navPricing')}
          </Link>
          <a
            href="https://discord.gg/guxmb6NERA"
            className="nav-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            {t('navCommunity')}
          </a>
          <button
            type="button"
            className="nav-cta"
            onClick={handleInstallClick}
          >
            {t('navInstall')}
          </button>
        </nav>
      </div>
    </motion.header>
  );
};

export default Header;
